import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BodyClassName from 'react-body-classname';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { CoreModal } from 'components/core/library/modal';
import ModalClose from './ModalClose';

import './modal.scss';

export default function Modal({ closeComponent = ModalClose, ...restProps }) {
	const props = { closeComponent, ...restProps };
	return (
		<BodyClassName className={classnames({ 'no-scroll': props.showing })}>
			<TransitionGroup>
				{!!props.showing &&
					<CSSTransition
						classNames="transition-fade-in"
						timeout={150}
					>
						<CoreModal {...props} />
					</CSSTransition>
				}
			</TransitionGroup>
		</BodyClassName>
	);
}

Modal.propTypes = {
	/** If the modal should be showing */
	showing: PropTypes.bool,
	/** If the modal should have a close button */
	closeable: PropTypes.bool,
	/** The component to use in the corner as the close button */
	closeComponent: PropTypes.func,
	/** Function to handle onClose events and manage the closed/open state */
	onClose: PropTypes.func,
};
